export class HashtagsManager{
    constructor(){
        this.eventListeners()
        this.init()
    }

    eventListeners() {
        $('.js-toggle-hashtags').on('click', () => this.toggleHashtags());
    }

    toggleHashtags() {
        $('.js-hashtags').toggleClass('show-all');
    }

    init() {
        fama.utils.debug('HashtagsManager loaded');
    }
}